import styled from "styled-components";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledActionsContainer = styled(FlexRow)`
    gap: 8px;
    align-items: center;
    flex: 1 0;

    & > :last-child {
        margin-left: auto;
    }
`;
